<div class="warehouse-group-table__wrapper" *ngIf="!loading; else loader">
  <table class="table border" *ngIf="data.length; else noRecords">
    <thead class="">
      <th>ID</th>
      <th>Label</th>
      <th>Description</th>
      <th>Warehouse</th>
      <th class="text-center" *ngIf="ftPickAndPackEnabled">Pick and Pack</th>
      <th class="actions">&nbsp;</th>
    </thead>
    <tbody>
      <tr *ngFor="let row of data; trackBy: trackById">
        <td>{{ row?.id }}</td>
        <td>{{ row?.label }}</td>
        <td>{{ row?.description }}</td>
        <td>
          <lum-ui-label
            *ngFor="let warehouse of row.warehouses; trackBy: trackById"
            [label]="warehouse?.locationName || ''"
          ></lum-ui-label>
        </td>
        <td class="text-center" *ngIf="ftPickAndPackEnabled">
          <lum-ui-label
            cssClasses="bg-green-600 text-white"
            [label]="ePickAndPackEnabledValue.MANUAL"
            *ngIf="row.pickAndPackEnabled; else no"
          ></lum-ui-label>
          <ng-template #no>
            <lum-ui-label
              [label]="ePickAndPackEnabledValue.AUTOMATIC"
            ></lum-ui-label>
          </ng-template>
        </td>
        <td class="p-0 text-dark">
          <button mat-icon-button [matMenuTriggerFor]="menu">
            <lum-ui-icon icon="menu-horizontal" color="#36363A"></lum-ui-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="onOpenDialog(row)">Edit</button>
            <button mat-menu-item (click)="onDelete(row.id)">Delete</button>
          </mat-menu>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<ng-template #loader>
  <div class="w-100">
    <mat-spinner diameter="20" class="mx-auto"></mat-spinner>
  </div>
</ng-template>

<ng-template #noRecords>
  <div class="text-center p-4">
    <h3>No records available.</h3>
  </div>
</ng-template>
